import React, { useEffect, useState } from "react";

import { DataView } from "primereact/dataview";
import { useLocation, useNavigate } from "react-router-dom";
import { getWarehouseCollection } from "../../services/WalletCollection/WalletCollection";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import StoreMenu from "../StoreMenu";
import SchedularModal from "../SchedularModal";
import { getSelectedTabListView, getStoreLocalData, getUserData, setSelectedTabListView } from "../../utils/localStorage";
import AdminMenu from "../AdminMenu";
import ButtonLink from "../../ButtonLink";
import useDashboardPaymentCollection from "../StoreContext/useDashboardPaymentCollection";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const { innerWidth: width, innerHeight: height } = window;

const WalletCollection = () => {
  const navigate = useNavigate();

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  const { storeLocalData } = getStoreLocalData();

  const {
    schedularDate,
    setSchedularDate
  } = useDashboardPaymentCollection();

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [walletCollectionData, setWalletCollectionData] = useState([]);
  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  // const [schedularDate, setSchedularDate] = useState({});

  const [tabularView, setTabularView] = useState(false);

  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListView(selectedType);
  };

  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListView();
      setTabularView(selectedInvoiceTypeData?.tabListView || "list");
    } catch {
      setTabularView("list");
    }
  };

  const { storeData, userProfileRole } = getUserData();

  const userRole = userProfileRole;

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const initializeVariable = () => {
    setWalletCollectionData([]);
  };

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const location = useLocation();
  const { orderFilterData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const getWalletCollectionData = (data) => {
    getWarehouseCollection(data).then((response) => {
      if (!response.data.error) {
        setWalletCollectionData(response.data);
      }
    });
  };

  useEffect(() => {
    const data = {
      storeIds: orderFilterData.storeIds,
      statusIn: orderFilterData.statusIn,
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
    };
    getWalletCollectionData(data);
    fetchSelectedTabListView();

  }, [orderFilterData, schedularDate]);


  const itemTemplate = (order, index) => {
    const OrderStatusColors = {
      DEFAULT: '#F5C43A',
    };

    const orderStatusColor = OrderStatusColors.DEFAULT;
    const formattedDate = formatDate(order.payment.date);
    return (
      <Accordion>
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": orderStatusColor,
          }}
          header={`${index + 1 || "N/A"
            } | ${formattedDate} `}
        >
          <div
            className="cursor-pointer"
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Customer Name:</p>
                <p className="text-lg font-bold capitalize">
                  {order.storeCustomerAccount.storeCustomer.brandCustomer
                    .firstName +
                    ' ' +
                    order.storeCustomerAccount.storeCustomer.brandCustomer
                      .lastName}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Mobile No.:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.storeCustomerAccount.storeCustomer.brandCustomer.mobile}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Amount:
                </p>
                <p className="text-lg font-bold capitalize">
                  {storeLocalData?.currencySymbol} {order.payment.amount}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div >{list}</div>;
  };

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={walletCollectionData}
        // header={header}
        paginator
        rows={50}
        rowsPerPageOptions={[50, 75, 100]}
        tableStyle={{ minWidth: "50rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 130}
      >
        <Column
          field="createdDate"
          header="Date"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => formatDateNew(rowData?.payment.date)}
        />

        <Column
          field="customerName"
          header="Customer Name"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) =>
            rowData.storeCustomerAccount.storeCustomer.brandCustomer
              .firstName +
            ' ' +
            rowData.storeCustomerAccount.storeCustomer.brandCustomer
              .lastName
          }
        />

        <Column
          field="Mobile"
          header="Mobile No."
          style={{
            width: "50px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData.storeCustomerAccount.storeCustomer.brandCustomer.mobile}

        />

        <Column
          field="Amount"
          header="Amount"
          style={{
            width: "40px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => storeLocalData?.currencySymbol + rowData.payment.amount}
        />


      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/full-dashboard")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Wallet Collection
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          {walletCollectionData.length > 0 && (
            <div
              onClick={() =>
                navigate("/WalletCollectionReceipt", {
                  state: {
                    walletCollectionData: walletCollectionData,
                    orderFilterData: orderFilterData,
                  },
                })
              }
              className="mx-2 cursor-pointer"
            >
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                style={{ width: 30 }}
              />
            </div>
          )}
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 30 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-3">
        {walletCollectionData.length > 0 ? (


          <div>
            <div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                >
                  <div className="report-table">
                    <div className="tab-view-table">{RenderTabView()}</div>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: tabularView === "tab" ? "none" : "" }}>
              <DataView
                value={walletCollectionData}
                listTemplate={listTemplate}
                paginator
                rows={20}
              />
            </div>
          </div>




        ) : walletCollectionData.length === 0 ? (
          <div>
            <p className="text-2xl font-semibold text-center">No Data Found</p>
          </div>
        ) : (
          <div>
            <p className="text-2xl font-semibold text-center">
              Wallet Collection is Loading...
            </p>
          </div>
        )}
      </div>

      {/* <WalletCollectionSchedularModal
        walletCollectionSchedularModalVisible={
          walletCollectionSchedularModalVisible
        }
        setWalletCollectionSchedularModalVisible={
          setWalletCollectionSchedularModalVisible
        }
        sendDataToWalletCollectionList={receiveDataFromSchedularModal}
      /> */}

      <SchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        typeOfOrder={orderFilterData.recordType}
      />

      {userRole === "BY_ADMIN" ||
        userRole === "BY_SUB_ADMIN_USER" ||
        userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
    </div>
  );
};

export default WalletCollection;
